import { Button, styled } from '@mui/material';

export const SubMenuBackButton = styled(Button)(({ theme: { palette } }) => ({
  minWidth: 32,
  height: 32,
  backgroundColor: palette.horizonWhite.main,
  color: palette.horizonText.main,
  fontSize: 12,
  borderRadius: 4,
  border: `1.5px solid ${palette.horizonGray5.main}`,
  ':hover': {
    backgroundColor: palette.horizonWhite.main,
  },
}));
